import React from "react";
import {
  View,
  Text,
  ImageBackground,
  Image,
  TouchableOpacity,
  ScrollView,
  Platform,
  Dimensions,
} from "react-native";
import { StatusBar } from "expo-status-bar";
import style from "./style";
import Menu from "../menu";
import api from "../config/api_urls";
import ReactMarkdown from "react-markdown";
import AsyncStorage from "@react-native-community/async-storage";
// import { PlayvisitEmbed } from "../joc2/PlayvisitEmbed";

export default class Intro360 extends React.Component {
  constructor(props) {
    super(props);
    this.state = props.route.params;
    this.state["current_page"] = this.state.projecte.pagines.find((page) => page.id == 26);

    // console.log(this.state);
  }

  componentDidMount() {
    // console.log("entra Pag 6");
    //Serveix per redirecionar al menu o als creditsInici
    AsyncStorage.setItem("anarCredits", true);
    // HARDCODED
    AsyncStorage.getItem('finished_games').then((value) => {
      if (value !== null) {
        value = JSON.parse(value)
        value.find((game) => game.gameId == 26) ?
        this.state.navigation.navigate("Premi360", this.state) : null
      }
    })
  }

  render() {
    return (
      <View style={{ flex: 1, flexGrow: 1 }}>
        <ImageBackground
          source={
            this.state.projecte["FonsPantalla6"]
              ? {
                  uri:
                    api.api_url +
                    this.state.projecte["FonsPantalla6"]
                      .url,
                }
              : null
          }
          style={style.imageBackground}
        >
          {/* Header */}
          <View
            style={{
              flex: 1,
              alignItems: "center",
              justifyContent: "center",
              width: "95%",
              alignSelf: "center",
            }}
          >
            <Text
              style={[
                style.titol,
                { fontFamily: "Brushway", fontSize: "4rem",paddingTop:'2rem',color:'#151615' },
              ]}
            >
              {this.state.current_page["Nom" + this.state.idioma]}
            </Text>
          </View>

          {/* Body */}
          {/* <View style={{flex:60}}> */}
          <View style={{ flex: 1 }}>
            <Image
              style={style.imageItinerari}
              source={{
                uri: api.api_url + this.state.current_page.Imatge?.url,
              }}
            />
          </View>

          <ScrollView
            style={[
              style.descriptionContainer,
              { flex: 2, maxHeight: Dimensions.get("window").height / 4 , paddingTop:'2rem' },
            ]}
          >
            <View
              style={{
                flex: 35,
                justifyContent: "center",
                alignSelf: "center",
              }}
            >
              <Text
                style={{
                  fontSize: "2.3vh",
                  fontFamily: "OpenSans",
                  textAlign: "center",
                  fontWeight:'bold'
                }}
              >
                {this.state.current_page["Tipus1Text" + this.state.idioma]}
              </Text>
            </View>
          </ScrollView>
          <TouchableOpacity
            onPress={() =>
            this.state.projecte.anarDirecteTrucada == false? this.state.navigation.navigate("Vista360", this.state) : window.alert('Not active')
            }
            style={{ alignSelf: "center", paddingTop: "2rem" }}
          >
            <View
              // style={[style.itinerariContainer, { backgroundColor: "#81beeb" }]}
            >
              {/* <Text style={{ fontSize: 14, fontWeight: "bold", padding: 5 }}>
                <Text style={[style.itinerariText]}>{this.state.recursos.find(e=> e.tipus_recurs == "play")["text_recurs"+this.state.idioma]}</Text>
              </Text> */}
              <Image
                style={{width:'8rem',height:'4rem',resizeMode:'contain',paddingTop:2}}
                source={{
                  uri: api.api_url + this.state.recursos.find(e=> e.tipus_recurs == "play")["imatge_recurs"+this.state.idioma].url,
                }}
              />
            </View>
          </TouchableOpacity>

          {/* Footer */}
          <View
            style={{
              flex: 0.7,
              alignSelf: "center",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            
          </View>
          <View
            style={{ flex: 2, bottom: 0, left: 0, right: 0, position: "fixed" }}
          >
            <Menu projecte={this.state}></Menu>
          </View>
        </ImageBackground>
      </View>
    );
  }
}
